import Http from './http';
import store from 'store';

class DashboardService {
    constructor() {
        this.dashboards = null;
        store.set('dashboards', false)
        
    }

    resetCache(){
        store.set('dashboards', false)
        this.dashboards = null;
        this.getDashboards()
    }

    getDashboards() {
        return new Promise((resolve, reject) => {
            if (store.get('dashboards', false)){
                this.dashboards = store.get('dashboards');
            }
            if (this.dashboards) resolve(this.dashboards);
            else {
                Http.get('/assigned-dashboards/').then(resp => {
                    this.dashboards = resp.data;
                    store.set('dashboards', this.dashboards)
                    resolve(resp.data);
                });
            }
        })
    }
}

export default new DashboardService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/dashboards.js